<template>
  <v-dialog
      v-model="show"
      max-width=570
      scrollable
  >
    <v-card>
      <v-card-title class="text-h5">
        Filter wählen
      </v-card-title>
      <v-card-text>
        <v-select
            hint="Das Feld nach dem gefiltert werden soll."
            persistent-hint
            :items="selectOptions"
            :label="'Feld auswählen'"
            v-model="selectedProperty"
        ></v-select>
        <v-btn-toggle v-model="comparator" mandatory color="primary" class="mt-3">
          <v-btn value="==">
            <v-icon left>mdi-equal</v-icon>
            <span class="hidden-sm-and-down">Gleich</span>
          </v-btn>
          <v-btn value="!=">
            <v-icon left>mdi-not-equal-variant</v-icon>
            <span class="hidden-sm-and-down">Ungleich</span>
          </v-btn>
          <v-btn value="<">
            <v-icon left>mdi-less-than</v-icon>
              <span class="hidden-sm-and-down">Kleiner als</span>
          </v-btn>
          <v-btn value=">">
            <v-icon left>mdi mdi-greater-than</v-icon>
            <span class="hidden-sm-and-down" style="text-transform: none">GRÖßER ALS</span>
          </v-btn>
        </v-btn-toggle>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
            color="primary"
            text
            @click="show = false"
        >
          Abbrechen
        </v-btn>

        <v-btn
            color="success darken-1"
            text
            :disabled="!selectedProperty"
            @click="addFilter"
        >
          Hinzufügen
        </v-btn>
      </v-card-actions>
    </v-card>
    </v-dialog>

</template>

<script>
import {v4} from "uuid";
export default {
  name: "AddFilterDialog",
  props: {
    definition: {
      type: Object,
      default: () => {
        return {
          id: '',
          name: '',
          category: '',
          description: '',
          properties: [],
          properties_order: [],
        }
      }
    },
  },
  data: () => ({
    show: false,
    comparator: "==",
    selectedProperty: null,
  }),
  computed: {
    selectOptions() {
      return this.definition.properties_order.map((property) => {
        const prop = this.definition.properties[property];
        if (!prop || prop.property_type === "sub_header") return null;
        return {
          text: prop.name,
          value: property,
        };
      });
    },
  },
  methods: {
    showDialog() {
      this.comparator = "==";
      this.selectedProperty = null;
      this.show = true;
    },
    addFilter() {
      let value = '';
      let prop = this.definition.properties[this.selectedProperty];
      if (prop && prop.property_type === 'boolean') {
          value = null;
      }
      prop.id = v4();
      prop.show = false;
      prop.comparator = this.comparator;
      const filter = {
        id: prop.id,
        value: value,
        property: prop,
      };
      this.$emit("add-filter", filter);
      this.show = false;
    },
  }
}
</script>

<style scoped>

</style>
